import { c as _c } from "react/compiler-runtime";
import { BodyLong, Heading, Link } from "@navikt/ds-react";
import Image from "next/image";
import type { ReactElement, ReactNode } from "react";
import notFoundMom from "../../../public/not-found-mom.svg";
import pageErrorDad from "../../../public/page-error-dad.svg";
import styles from "./error.module.css";
interface Props {
  graphic?: "dad" | "mom";
  text?: string;
  details?: ReactNode;
  action?: ReactNode | null;
  noReload?: boolean;
}
const PageError = t0 => {
  const $ = _c(19);
  const {
    graphic: t1,
    text,
    details,
    noReload: t2
  } = t0;
  const graphic = t1 === undefined ? "dad" : t1;
  const noReload = t2 === undefined ? false : t2;
  const errorText = text ?? "Det har oppst\xE5tt en uventet feil";
  let t3;
  if ($[0] !== graphic) {
    t3 = graphic === "dad" ? <Image className={styles.errorimage} src={pageErrorDad} alt="" /> : <Image className={styles.errorimage} src={notFoundMom} alt="" />;
    $[0] = graphic;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Heading spacing={true} size="large" level="1">Oops!</Heading>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== errorText) {
    t5 = <Heading spacing={true} size="small" level="2">{errorText}</Heading>;
    $[3] = errorText;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = !details;
  let t7;
  if ($[5] !== noReload) {
    t7 = !noReload && <>Du kan prøve å{" "}<Link href={window.location.href}>laste siden på nytt</Link>.</>;
    $[5] = noReload;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t6 || $[8] !== t7) {
    t8 = <BodyLong spacing={t6}>{t7}</BodyLong>;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== details) {
    t9 = details ?? <BodyLong spacing={true}>Vi jobber allerede med å fikse feilen.</BodyLong>;
    $[10] = details;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t5 || $[13] !== t8 || $[14] !== t9) {
    t10 = <div>{t4}{t5}{t8}{t9}</div>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t3) {
    t11 = <div className={styles.errorcontainer} role="alert" aria-live="polite">{t3}{t10}</div>;
    $[16] = t10;
    $[17] = t3;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};
export default PageError;